import { z } from 'zod';

import { exploreColumnSchema } from './explore-column';
import { exploreRowSchema } from './explore-row';

export type ExploreStatisticsData = z.output<typeof exploreStatisticsDataSchema>;
export type ExploreStatisticsDataDTO = z.input<typeof exploreStatisticsDataSchema>;

export const exploreStatisticsDataSchema = z.object({
  columns: z.array(exploreColumnSchema),
  rows: z.array(exploreRowSchema),
});
